module.exports = __webpack_public_path__ + "static/img/产品图2@3x.1df9a47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/产品图2@3x.png
// module id = TJ+i
// module chunks = 192